import { render } from "./StatsCardMini.vue?vue&type=template&id=016b73b4&scoped=true"
import script from "./StatsCardMini.vue?vue&type=script&lang=js"
export * from "./StatsCardMini.vue?vue&type=script&lang=js"

import "./StatsCardMini.vue?vue&type=style&index=0&id=016b73b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016b73b4"]])

export default __exports__